import enLang from "./entries/en-US";
import ruLang from "./entries/ru-RU";
import frLang from "./entries/fr-FR";

//TODO. remove it, fix it, or smthg like this
const AppLocale = {
    en: enLang,
    ru: ruLang,
    fr: frLang,
    en_US: enLang,
    ru_RU: ruLang,
    fr_FR: frLang,
};

export default AppLocale;
